export default __webpack_public_path__ + "static/media/👋🏻.6dd9e3e6.svg";